<template>
<div class="page page_hezuo">
    <div class="bg tradesman">生命因传承而精彩</div>
    <!-- 基本信息 -->
    <div v-if="step==1">
        <div class="step">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">输入信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">审核</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">成功入驻</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap">
            <div class="item flex" @click="shopRolePicker=true">
                <div class="item_l">
                    <div class="title">店铺角色</div>
                    <van-field v-model="shopRoleName" placeholder="请选择" />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item flex" @click="rolePicker=true">
                <div class="item_l">
                    <div class="title">店铺类型</div>
                    <div class="name">{{role}}</div>
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item">
                <div class="title">姓名</div>
                <div class="name">
                    <van-field v-model="legal_person" placeholder="请输入店主的真实姓名" />
                </div>
            </div>
            <div class="item">
                <div class="title">身份证号</div>
                <div class="name">
                    <van-field v-model="id_number" placeholder="请输入店主身份证号" />
                </div>
            </div>
            <div class="item">
                <div class="title">上传身份证正反面照片</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+legal_photo_facade" />
                        </div>
                        <div class="img_tip">正面示例</div>
                    </div>
                    <!-- <div class="">正面</div> -->
                    <div class="">
                        <van-uploader :after-read="onFacadeRead" accept class="icon-add" ref="legal_photo_facade">
                            <div class="addPhone"></div>
                        </van-uploader>
                        <!-- <div class="">正面</div> -->
                    </div>       
                </div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+legal_photo_back" />
                        </div>
                        <div class="img_tip">反面示例</div>
                    </div>
                    <van-uploader :after-read="onBackRead" accept class="icon-add" ref="legal_photo_back">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item flex" @click="areaPicker=true" v-if="shopRole.type != 3">
                <div class="item_l">
                    <div class="title">省市区</div>
                    <van-field v-model="area" placeholder="请选择" readonly />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item" v-if="shopRole.type != 3">
                <div class="title">详细信息</div>
                <div class="name">
                    <van-field v-model="street" placeholder="如道路、门牌号、小区、楼栋号等" />
                </div>
            </div>
            <div class="item">
                <div class="title">手机号</div>
                <div class="name">
                    <van-cell :title="username" />
                </div>
            </div>
        </div>
        <!-- 协议 -->
        <div class="xieyi" v-if="shopRole.type != 3">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
            <div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(3)">“匠人入驻协议”</span></div>
        </div>
		<!-- 园区入驻协议 -->
		<div class="xieyi" v-if="shopRole.type == 3">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
			<div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(11)">“匠人园区入驻协议”</span></div>
        </div>
        <!-- 入驻 -->
        <div class="big_btn" @click="ruzhu">入驻</div>
    </div>
    <!-- 公司信息 -->
    <div v-if="step==2">
        <div :class="roleType == 1 && shopRole.type != 3? 'step item4' : 'step' ">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">基本信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item active">
                <div class="step_name">公司信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item" v-if="shopRole.type != 3">
                <div class="step_name">匠人信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">店铺信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap">
            <div class="item">
                <div class="title">企业名称</div>
                <van-field v-model="company_name" placeholder="请输入企业名称..." />
            </div>
            <div class="item">
                <div class="title">机构代码</div>
                <van-field v-model="company_code" placeholder="请输入企业机构代码..." />
            </div>
            <div class="item">
                <div class="title">上传个体工商户营业执照</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box" v-if="license">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+license" />
                        </div>
                    </div>
                    <van-uploader :after-read="onUploadLicense" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">资质证书</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box" v-if="qualification">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+qualification" />
                        </div>
                    </div>
                    <van-uploader :after-read="onQualificationRead" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                    <!-- <div class="tu_tip">图片类型jpg/jpeg/png，165*165，大小5M内</div> -->
                </div>

            </div>
        </div>
        <!-- 上一步 下一步 -->
        <div class="actions">
            <div class="action prev" @click="goPrePage">上一步</div>
            <div class="action next" @click="goPersonPage">下一步</div>
        </div>
    </div>
    <!-- 个人信息 -->
    <div v-if="step==3">
        <div :class="roleType == 1 && shopRole.type != 3? 'step item4': 'step'">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">基本信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item active" v-if="roleType == 1">
                <div class="step_name">公司信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item active" v-if="shopRole.type != 3">
                <div class="step_name">匠人信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">店铺信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap">
            <div class="item flex">
                <div class="item_l">
                    <div class="title">匠人等级</div>
                    <van-field v-model="auth_level" placeholder="请输入匠人等级..." />
                </div>
            </div>
            <div class="item flex" @click="showCate=true">
                <div class="item_l">
                    <div class="title">匠人分类</div>
                    <van-field v-model="cateName" placeholder="请选择匠人分类..." readonly />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item flex" @click="showSkill=true">
                <div class="item_l">
                    <div class="title">技艺类型</div>
                    <van-field v-model="skillName" placeholder="请选择技艺类型..." readonly />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item">
                <div class="title">助力技艺（活动）</div>
                <van-field v-model="helpless_skill" placeholder="请输入匠人的助力技艺..." />
            </div>
        </div>
        <!-- 上一步 下一步 -->
        <div class="actions">
            <div class="action prev" @click="goPrePage">上一步</div>
            <div class="action next" @click="goDonePage">下一步</div>
        </div>
    </div>
    <div v-if="step==4">
        <div :class="roleType == 1 && shopRole.type != 3? 'step item4' : roleType == 2 && shopRole.type == 3 ? 'step item2' :'step' ">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">基本信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item active" v-if="roleType == 1">
                <div class="step_name">公司信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item active" v-if="shopRole.type != 3">
                <div class="step_name">匠人信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item active">
                <div class="step_name">店铺信息</div>
                <div class="step_icon active">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap">
            <div class="item">
                <div class="title">店铺名称</div>
                <van-field v-model="nickname" placeholder="请输入店铺名称..." />
            </div>
            <div class="item flex" @click="showPark=true" v-if="shopRole.type == 3">
                <div class="item_l">
                    <div class="title">园区类型</div>
                    <van-field v-model="parkName" placeholder="请选择园区类型..." readonly />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item flex">
                <div class="item_l">
                    <div class="title">经营类型</div>
                    <van-field v-model="business_type" placeholder="请输入经营类型..." />
                </div>
                <!-- <div class="item_r">选择</div> -->
            </div>
            <div class="item">
                <div class="title">简介</div>
                <van-field v-model="jieshao" placeholder="请输入店铺简介..." />
            </div>
            <div class="item">
                <div class="title">工作、作品照片</div>
                <div class="upload-images">
                    <div class="image_wrap" v-if="works">
                        <img class="image" :src="imageUrl+works" />
                        <!-- <div class="del"></div> -->
                    </div>
                    <van-uploader :after-read="upWorkerTu" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
                <!-- <div class="tu_tip">图片类型jpg/jpeg/png，165*165，大小5M内</div> -->
            </div>
            <div class="item">
                <div class="title">版权信息</div>
                <div class="upload-images">
                    <div class="image_wrap" v-if="copyRight">
                        <img class="image" :src="imageUrl+copyRight" />
                        <!-- <div class="del"></div> -->
                    </div>
                    <van-uploader :after-read="upCopyrightTu" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
                <!-- <div class="tu_tip">图片类型jpg/jpeg/png，165*165，大小5M内</div> -->
            </div>
        </div>
        <!-- 上一步 下一步 -->
        <div class="actions">
            <div class="action prev" @click="goPrePage">上一步</div>
            <div class="action next" @click="applyTradesman">完成</div>
        </div>
    </div>
    <!--  -->
    <!-- 角色弹层 -->
    <van-popup v-model="rolePicker" position="bottom">
        <van-picker show-toolbar :columns="roleList" @cancel="rolePicker = false" @confirm="confrimRole" />
    </van-popup>
    <!-- 分类弹层 -->
    <van-popup v-model="showCate" position="bottom">
        <van-picker show-toolbar :columns="cateList" @cancel="showCate = false" @confirm="confrimCate" />
    </van-popup>
    <!-- 技艺弹层 -->
    <van-popup v-model="showSkill" position="bottom">
        <van-picker show-toolbar :columns="skillList" @cancel="showSkill = false" @confirm="confrimSkill" />
    </van-popup>
    <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="confrimArea" @cancel="areaPicker=false" />
    </van-popup>
    <!-- 园区弹层 -->
    <van-popup v-model="showPark" position="bottom">
        <van-picker show-toolbar :columns="parkList" value-key="name" @cancel="showPark = false" @confirm="confrimPark" />
    </van-popup>
	<!-- 店铺角色弹层 -->
	<van-popup v-model="shopRolePicker" position="bottom">
        <van-picker show-toolbar :columns="shopRoleList" value-key="name" @cancel="shopRolePicker = false" @confirm="confrimShopRole" />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import {
    Uploader
} from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            step: 1,
            role: '个人',
            roleType: 2, // 个人2 , 公司1
            rolePicker: false,
            roleList: ['个人', '公司'],
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            checked_xieyi: true, // 勾选协议
            id_number: '', // 身份证号
            legal_person: '', // 真实姓名
            street: '', // 详细信息
            area: '', // 所选省市区
            area_name1: '', // 省
            area_name2: '', // 市
            area_name3: '', // 区
            areaList: {}, // 省市区列表
            areaPicker: false, // 省市区pop弹层
            token: '',
            legal_photo_facade: null, //身份证正面照片
            legal_photo_back: null, //身份证背面照片
            company_name: null, // 企业名称
            company_code: null, // 机构代码
            license: null, // 营业执照
            imageUrl: Vue.prototype.$publicData.uploadImage,
            default_image: this.$publicData.intangibleDefault,
            jieshao: null, // 简介
            business_type: null, // 经营类型
            checked: true, // 是否默认
            nickname: '', // 店铺名称
            username: '', //手机号
            auth_level: '', //匠人等级
            helpless_skill: '', //助力技艺
            skillResult: [],
            showSkill: false,
            skillList: [],
            skillId: '',
            skillName: '',
            cateResult: [],
            showCate: false,
            cateList: [],
            cate_id: '', //分类
            cateName: '',
            company_photo: null, //证书
            works: null, //工作照
            qualification: null, //资质证书
            copyRight: null, //版权说明
            bank: '',
            bank_person: '',
            bank_code: '',
            bank_address: '',
            showPark: false, // 园区picker
            parkName: '', // 园区类型
            parkList: [], // 园区列表
            park_uuid: null,
            shopRoleName: '匠人', // 店铺角色 默认匠人
            shopRolePicker: false, //
            shopRoleList: [{
                    type: 1,
                    name: '匠人'
                },
                {
                    type: 2,
                    name: '专家'
                },
                {
                    type: 3,
                    name: '园区商户'
                },
            ],
            shopRole: {
				type: 1,
                name: '匠人'
			}
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '申请成为匠人'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
                    this.getAreaData()
                    this.getSkillData()
                    this.getCateData()
                    this.getParkData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getUserData()
            this.getAreaData()
            this.getSkillData()
            this.getCateData()
            this.getParkData()
        }
        console.log('this.addressId:' + this.addressId)

    },
    methods: {
        getUserData() {
            console.log('123')
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    this.username = res.result.info.users.username
                    console.log(this.username)
                }
            })
        },
        getSkillData() {
            var params = {}
            this.$api.tradesman.skill(params).then(res => {
                if (res.code == 200) {
                    this.skillResult = res.result.list
                    var ss = []
                    for (let i = 0; i < this.skillResult.length; i++) {
                        const skill = this.skillResult[i];
                        if (i == 0) {
                            this.skillId = skill.id
                            this.skillName = skill.name
                        }
                        ss.push(skill.name)
                    }
                    this.skillList = ss
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getCateData() {
            var params = {}
            this.$api.tradesman.cate(params).then(res => {
                if (res.code == 200) {
                    this.cateResult = res.result.list
                    var ss = []
                    for (let i = 0; i < this.cateResult.length; i++) {
                        const cate = this.cateResult[i];
                        if (i == 0) {
                            this.cate_id = cate.id
                            this.cateName = cate.name
                        }
                        ss.push(cate.name)
                    }
                    this.cateList = ss
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getAreaData() {
            var params = {}
            this.$api.address.areaList(params).then(res => {
                if (res.code == 200) {
                    var area = JSON.parse(res.result)
                    this.areaList = area.areaList
                    console.log(this.areaList)
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 确认选中地区
        confrimArea(data) {
            this.areaPicker = false;
            var area = ''
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (i == 0) {
                    this.area_name1 = item.code
                } else if (i == 1) {
                    this.area_name2 = item.code
                } else if (i == 2) {
                    this.area_name3 = item.code
                }
                area += item.name
            }
            this.area = area
            console.log('省市区', data)
        },
        // 图片身份证正面上传
        onFacadeRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    this.legal_photo_facade = res.result.url;
                }
            });
        },
        // 图片身份证反面上传
        onBackRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    this.legal_photo_back = res.result.url;
                }
            });
        },
        // 图片资质证明上传Qualification
        onQualificationRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.qualification = res.result.url;
                }
            });
        },
        // 上传营业执照
        onUploadLicense: function (file) { //license
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    this.license = res.result.url;
                }
            });
        },
        // 上传资质
        onUploadZizhi: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    this.license = res.result.url;
                }
            });
        },
        // 上传作品图
        upWorkerTu: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    this.works = res.result.url;
                }
            });
        },
        // 上传资质图
        upCopyrightTu: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    this.copyRight = res.result.url;
                }
            });
        },
        applyTradesman() {
            if (this.nickname == null || this.nickname == undefined || this.nickname == '') {
                this.$toast('请输入店铺名称')
                return
			}
			
			// 当店铺角色为园区商户时, 园区类型必须填写
			if(this.shopRole.type == 3){
				if(!this.park_uuid){
					this.$toast('请选择园区类型')
					return
				}
			}

            if (this.works == null || this.works == undefined || this.works == '') {
                this.$toast('请上传工作照片')
                return
            }
            if (this.copyRight == null || this.copyRight == undefined || this.copyRight == '') {
                this.$toast('请上传版权信息照片')
                return
			}
			
            var params = {
				token: this.token,
				tradesman_role: this.shopRole.type == 1 ? 0 : this.shopRole.type == 2 ? 2 : 1 , // 0匠人 1园区 2专家
                username: this.username,
                nickname: this.nickname,
                type: this.roleType,
                cate_id: this.cate_id,
                address: this.street,
                area1: this.area_name1,
                area2: this.area_name2,
                area3: this.area_name3,
                legal_person: this.legal_person,
                legal_code: this.id_number,
                legal_photo_facade: this.legal_photo_facade,
                legal_photo_back: this.legal_photo_back,
                company_photo: this.license,
                company_name: this.company_name,
                company_code: this.company_code,
                works: this.works
            }
            if (this.park_uuid) {
                params.park_uuid = this.park_uuid
			}
			// 匠人、专家入驻, 需填写匠人相关信息；园区商户入驻无需填写
			if(this.shopRole.type != 3){
				params.auth_company =  this.auth_level
				params.helpless_skill =  this.helpless_skill
                params.skill =  this.skillId
			}

            // console.log('params 提交的全部字段', params)
            this.$api.my.applyTradesman(params).then(res => {
                if (res.code == 200) {
					this.$toast(res.message)
					var that = this
					this.getApplyStatus(function(){
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
							//返回上级页面
							var params = {
								'data': {}
							}
							that.$bridge.callhandler('sdjy://public/back', params, (data) => {

							})
						} else {
							that.$router.back()
						}
					})
                    

                } else {
                    this.$toast(res.message ? res.message : res.msg)
                }
            })

        },
        // 选角色 公司入驻还是个人入驻
        confrimRole(val) {
            console.log('val', val)
            this.role = val
            this.rolePicker = false
            if (this.role == '个人') {
                this.roleType = 2
            } else {
                this.roleType = 1
            }
        },
        //选择分类
        confrimCate(val) {
            this.cateName = val
            this.showCate = false
            for (let i = 0; i < this.cateResult.length; i++) {
                const cate = this.cateResult[i];
                if (this.cateName == cate.name) {
                    this.cate_id = cate.id
                }
            }
        },
        //选择技艺
        confrimSkill(val) {
            this.skillName = val
            this.showSkill = false
            for (let i = 0; i < this.skillResult.length; i++) {
                const skill = this.skillResult[i];
                if (this.skillName == skill.name) {
                    this.skillId = skill.id
                }
            }
        },
        // 入驻
        ruzhu() {
            if (this.legal_person == null || this.legal_person == undefined || this.legal_person == '') {
                this.$toast('请输入店主真实姓名')
                return
            }
            if (this.id_number == null || this.id_number == undefined || this.id_number == '') {
                this.$toast('请输入店主身份证号')
                return
            }
            if (this.legal_photo_facade == null || this.legal_photo_facade == undefined || this.legal_photo_facade == '') {
                this.$toast('请上传身份证正面照片')
                return
            }
            if (this.legal_photo_back == null || this.legal_photo_back == undefined || this.legal_photo_back == '') {
                this.$toast('请上传身份证反面照片')
                return
			}
			// 非园区, 必填省市区和详细地址
			if(this.shopRole.type != 3){
				if (this.area_name3 == null || this.area_name3 == undefined || this.area_name3 == '') {
					this.$toast('请选择省市区')
					return
				}
				if (this.street == null || this.street == undefined || this.street == '') {
					this.$toast('请输入详细地址')
					return
				}
			}
            
            if (this.username == null || this.username == undefined || this.username == '') {
                this.$toast('请输入手机号')
                return
			}
			if(!this.checked_xieyi){
				this.$toast('请勾选协议')
                return
			}
            if (this.role == '个人' && this.shopRole.type != 3) {
                this.step = 3
			} else if(this.role == '个人' && this.shopRole.type == 3){
				this.step = 4
			}
			else {
                this.step = 2
            }

        },
        // 公司下一步操作
        goPersonPage() {
            if (this.company_name == null || this.company_name == undefined || this.company_name == '') {
                this.$toast('请输入企业名称')
                return
            }
            if (this.company_code == null || this.company_code == undefined || this.company_code == '') {
                this.$toast('请输入企业机构代码')
                return
            }
            if (this.license == null || this.license == undefined || this.license == '') {
                this.$toast('请上传营业执照照片')
                return
            }
            if (this.qualification == null || this.qualification == undefined || this.qualification == '') {
                this.$toast('请上传资质证书')
                return
			}
			if(this.shopRole.type == 3){
				this.step = 4
			}else{
				this.step = 3
			}
        },
        //个人下一步操作
        goDonePage() {
            if (this.auth_level == null || this.auth_level == undefined || this.auth_level == '') {
                this.$toast('请输入匠人等级')
                return
            }
            if (this.skillId == null || this.skillId == undefined || this.skillId == '') {
                this.$toast('请选择技艺类型')
                return
            }
            if (this.cate_id == null || this.cate_id == undefined || this.cate_id == '') {
                this.$toast('请选择匠人分类')
                return
            }
            if (this.helpless_skill == null || this.helpless_skill == undefined || this.helpless_skill == '') {
                this.$toast('请输入匠人的助力技艺')
                return
            }
            this.step = 4
		},
        //上一步
        goPrePage() {
			console.log('上一步',this.step)
			if(this.role == '个人' && this.step == 4 && this.shopRole.type == 3){
				this.step = 1
				return
			}
			if(this.step == 4 && this.shopRole.type == 3){
				this.step = 2
				return
			}
            if (this.step == 4 || this.step == 2) {
                this.step = this.step - 1
                return
            }
            var role = 0 // 个人传0, 公司传1
            if (this.role == '个人') {
                this.step = 1
            } else {
                this.step = 2
            }
        },
        // 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议
        goSinglePage(id) {
            this.$router.push({
                path: '/single/page',
                query: {
                    id: id
                }
            })
        },
        // 获取园区类型
        getParkData() {
            var params = {
                token: this.token
            }
            this.$api.tradesman.getTradesmanPark(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    // var item = {
                    //     name: '无',
                    //     park_uuid: 0
                    // }
                    // list.unshift(item)
                    this.parkList = list
                    // this.parkName = list[0].name
                }
            })
        },
        // 确认所属园区
        confrimPark(value) {
            // console.log('value',value)
            this.parkName = value.name
            if (value.park_uuid != 0) {
                this.park_uuid = value.park_uuid
            }
            this.showPark = false
		},
		// 确认店铺角色
		confrimShopRole(val){
			this.shopRoleName = val.name
			this.shopRole = val
			this.shopRolePicker = false
		},
		// 获取申请角色的审核状态
		getApplyStatus(callback) {
            var params = {
				type: 1, // 1匠人2供应商3代理商4城市合伙人
				token: this.token
			}
			this.$api.my.roleStatus(params).then(res => {
                    if (res.code == 200) {
						//res.result 0认证中1认证通过2未通过3未申请
						localStorage.setItem('tradesman_apply_status',res.result)
						console.log('res.result',res.result)
						callback()
                    }
                })
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
